import React from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Platforms from "@/components/landing/Platforms";
import Services from "@/components/landing/Services";
import FeaturedCreators from "@/components/landing/FeaturedCreators";
import CaseStudies from "@/components/landing/CaseStudies";
import Process from "@/components/landing/Process";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import JoinNetwork from "@/components/landing/JoinNetwork";

const Landing = () => {
  return (
    <div className="bg-zinc-950 min-h-screen text-zinc-100" data-testid="landing-page">
      <Nav />
      <Hero />
      <Platforms />
      <Services />
      <FeaturedCreators />
      <CaseStudies />
      <Process />
      <Testimonials />
      <JoinNetwork />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default Landing;
